import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routeMetadata } from '../routes/routeConfig';

// Hook personalizado para actualizar el título de la página
export const usePageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const metadata = routeMetadata[location.pathname];
        const title = metadata?.pageTitle || 'CICLII - Tu compañera digital';
        document.title = title;
    }, [location.pathname]);
};

export default usePageTitle;